<mat-drawer-container class="drawer-container" [hasBackdrop]="'false'">
  <mat-drawer class="drawer" #drawer [mode]="'over'">
    <div style="position: absolute; top: 15px; right: 15px; cursor: pointer" (click)="drawer.toggle()">
      <usimweb-icon [autofocus]="false" [icon]="'close'" style="color: #373737"></usimweb-icon>
    </div>
    <usimweb-generic-chat *ngIf="drawer.opened" [ids]="ids" [dialogService]="dialogService_"></usimweb-generic-chat>
  </mat-drawer>

  <mat-drawer-content>
    <ng-container *ngrxLet="results$ as results">
      <usimweb-status-bar
        *ngIf="results && results.foaming && results.foaming.length > 0"
        style="top: 0px !important; height: 20px"
        [progress]="results.foaming[0].progress"
      ></usimweb-status-bar>
    </ng-container>

    <div *ngIf="isFailed" style="padding: 10px">
      <usimweb-button-icon
        [icon]="'arrow_back'"
        fontColor="white"
        style="margin-top: 0px !important"
        (btnClick)="back()"
      ></usimweb-button-icon>
      <div>
        <!-- <usimweb-button-icon
          *ngIf="isOwner"
          [icon]="'refresh'"
          fontColor="white"
          style="position: absolute; top: 25px; right: 15px"
          tooltip="Restart simulation"
          (btnClick)="refreshResults()"
        ></usimweb-button-icon> -->
      </div>
    </div>

    <div class="container-fluid" *ngIf="!isFailed">
      <div class="row">
        <div class="col-xl-6 col-lg-12" style="min-width: 720px">
          <div style="margin-bottom: 30px">
            <div style="display: inline-block; margin-left: 0px; margin-top: 20px">
              <usimweb-button-icon
                [icon]="'arrow_back'"
                fontColor="white"
                style="margin-top: 0px !important"
                (btnClick)="back()"
              ></usimweb-button-icon>
            </div>

            <div *ngrxLet="results$ as results" style="display: inline-block; margin-left: 15px; margin-top: 25px">
              <p *ngIf="results && results.foaming && results.foaming.length > 0" style="font-size: 18px">
                Report: {{ results.foaming[0].title || 'no result preview' }}
              </p>
            </div>

            <!-- <div style="display: inline-block; margin-left: 30px; margin-top: 20px">
              <usimweb-button [text]="'3D Analyzer'" (btnClick)="openAnalyzer()" color="#f49602"></usimweb-button>
            </div> -->

            <usimweb-button style="margin-left: 20px" (btnClick)="openVersionsDialog()" text="Compare"></usimweb-button>

            <div style="display: inline-block; margin-left: 15px; margin-top: 17px">
              <div style="display: inline-block; cursor: pointer" (click)="downloadPpx()">
                <img src="assets/pp_icon.png" alt="assets/pp_icon.png" width="32" height="32" />
              </div>
            </div>

            <div *ngrxLet="results$ as results" style="display: inline-block; margin-left: 15px; margin-top: 12px">
              <div
                *ngIf="results && results.foaming && results.foaming.length > 0 && results.foaming[0].progress < 100"
              >
                <span style="color: orange; font-weight: bold">Processing:</span>
                {{ results.foaming[0].progress }}%
              </div>
            </div>
          </div>

          <div class="button-sidebar">
            <button class="chat-button" (click)="drawer.toggle()">
              <usimweb-icon [icon]="'add_comment'" [outlined]="true"></usimweb-icon>
            </button>
          </div>

          <mat-tab-group style="min-height: 550px; min-width: 720px; margin-left: 100px">
            <mat-tab label="Results">
              <div *ngrxLet="results$ as results" style="margin-top: 3px">
                <app-results-chart
                  *ngIf="results.results && results.results.length > 0"
                  [data]="results.results[0].data"
                  [layout]="results.results[0].layout"
                  (selectedPlotTypeEvent)="getResultCurves($event)"
                ></app-results-chart>
              </div>

              <div *ngrxLet="results$ as results">
                <usimweb-loader *ngIf="results && !results.report" [enabled]="true"></usimweb-loader>
              </div>
            </mat-tab>
            <mat-tab label="Measurements data">
              <div *ngIf="measurements.length > 0">
                <app-measurement-data-chart [measurements]="measurements"></app-measurement-data-chart>
              </div>
            </mat-tab>
            <mat-tab label="Report">
              <div style="padding: 15px" *ngrxLet="results$ as results">
                <app-report
                  *ngIf="results && results.report && results.report.length > 0"
                  [results]="results.report[0].task_result"
                ></app-report>
              </div>
            </mat-tab>
            <mat-tab label="Input parameters">
              <div *ngrxLet="results$ as results" style="padding: 15px">
                <app-input-parameters
                  *ngIf="
                    results &&
                    results.recipe &&
                    results.recipe.length > 0 &&
                    results.foaming &&
                    results.foaming.length > 0
                  "
                  [foaming]="results.foaming[0]"
                  [recipe]="results.recipe[0].name"
                ></app-input-parameters>
              </div>
            </mat-tab>

            <mat-tab label="Mold">
              <div *ngrxLet="results$ as results" style="padding: 15px">
                <app-model *ngIf="results && results.foaming" [foaming]="results.foaming[0]"></app-model>
              </div>
            </mat-tab>
          </mat-tab-group>

          <ng-container *ngrxLet="results$ as results">
            <div
              *ngIf="results && results.foaming && results.foaming.length > 0 && results.recipe.length > 0"
              style="margin-left: 100px; margin-top: 10px"
            >
              <div style="display: inline-block">
                <span class="dot"></span>
              </div>

              <div *ngrxLet="results$ as results" style="display: inline-block; margin-left: 15px">
                {{ results.foaming[0].materialName }} ' - ' {{ results.recipe[0].name }}
                {{ results.recipe[0].place }} at {{ results.foaming[0].materialTemperature }} °C
              </div>

              <div *ngrxLet="results$ as results" class="material">Created at {{ results.foaming[0].created }}</div>
            </div>
          </ng-container>
        </div>

        <div *ngrxLet="results$ as results" class="offset-xl-1 col-xl-5 col-lg-12">
          <div
            *ngIf="results && results.foaming && results.foaming.length > 0"
            style="margin-left: 0px; margin-top: 100px"
          >
            <p *ngIf="!isOwner" class="confidential-message">
              This projects contains confidential data shared by {{ results.foaming[0].created_by }}
            </p>

            <div class="row" style="width: 98%">
              <div class="col">
                <div class="mapScalarButtonsDiv">
                  <div style="display: inline-block">
                    <div *ngIf="selectedResult === 'density'; else noDensity">
                      <button
                        (click)="setDensity()"
                        class="mapScalarButton"
                        style="color: #f49602 !important"
                        type="button"
                      >
                        Density
                      </button>
                    </div>

                    <ng-template #noDensity>
                      <button (click)="setDensity()" class="mapScalarButton" type="button">Density</button>
                    </ng-template>
                  </div>

                  <div style="display: inline-block">
                    <div *ngIf="selectedResult === 'rt'; else noRT">
                      <button (click)="setRT()" class="mapScalarButton" style="color: #f49602 !important" type="button">
                        Residence time
                      </button>
                    </div>

                    <ng-template #noRT>
                      <button (click)="setRT()" class="mapScalarButton" type="button">Residence time</button>
                    </ng-template>
                  </div>

                  <div style="display: inline-block">
                    <div *ngIf="selectedResult === 'pressure'; else noPressure">
                      <button
                        (click)="setPressure()"
                        class="mapScalarButton"
                        style="color: #f49602 !important"
                        type="button"
                      >
                        Pressure
                      </button>
                    </div>

                    <ng-template #noPressure>
                      <button (click)="setPressure()" class="mapScalarButton" type="button">Pressure</button>
                    </ng-template>
                  </div>

                  <div style="display: inline-block">
                    <div *ngIf="selectedResult === 'shearStress'; else noshearStress">
                      <button
                        (click)="setShearStress()"
                        class="mapScalarButton"
                        style="color: #f49602 !important"
                        type="button"
                      >
                        Shear stress
                      </button>
                    </div>

                    <ng-template #noshearStress>
                      <button (click)="setShearStress()" class="mapScalarButton" type="button">Shear stress</button>
                    </ng-template>
                  </div>

                  <div style="display: inline-block">
                    <ng-template #Stop>
                      <usimweb-button-icon
                        [icon]="'stop'"
                        fontColor="white"
                        color="#6c757d"
                        (btnClick)="stopAnimation()"
                        class="mapScalarButton"
                      ></usimweb-button-icon>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <div style="position: relative; height: 400px">
              <div style="position: absolute">
                <ceetron-viewer [modelId]="'0'" #viewer></ceetron-viewer>
                <div *ngIf="animationBarOpen" class="animationBar">
                  <app-animation-toolbar></app-animation-toolbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
